import moment from 'moment';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getReturnedOrderHistory } from '../../apis/orders';
import { DirectoryBar } from '../../components/DirectoryBar';
import { FrontPagination } from '../../components/FrontPagination';
import { H6 } from '../../components/H6';
import { MProductCard } from '../../components/MyPage/MProductCard';
import TrackingNumber from '../../components/MyPage/TrackingNumber';
import { SearchField } from '../../components/SearchField';
import { Section } from '../../components/Section';
import { Table } from '../../components/Table';
import { OrderSummary } from '../../types/types';
import { orderStatusCase, requestStatusCase } from '../../utils/orderStatus';
import { MyPageStoreTabs } from './MyPageStoreTabs';

export const MyPageRefunds = () => {
    const [page, setPage] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(true);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [orders, setOrders] = useState<OrderSummary[]>([]);
    const [store, setStore] = useState<'ONLINE' | 'OFFLINE' | undefined>(
        undefined,
    );
    const [keyword, setKeyword] = useState<string>('');

    useEffect(() => {
        getList();
    }, [page, store]);

    const getList = () => {
        const params = { keyword, store };
        setIsLoading(true);
        getReturnedOrderHistory(page, 10, params).then(r => {
            setOrders(r.data.payload.content);
            setTotalPage(r.data.payload.totalPages);
        }).finally(() =>
            setIsLoading(false)
        );
    };

    return (
        <>
            <DirectoryBar text="교환 · 반품 내역" backArrow className="md:hidden" />
            <div className="py-4">
                <H6 className="">교환 · 반품 내역</H6>
                <div className="my-4 pb-4 flex flex-col md:p-0 md:flex-row md:justify-between ">
                    <MyPageStoreTabs onChange={type => setStore(type)} />
                    <SearchField
                        placeholder="검색하기"
                        onChange={e => setKeyword(e.target.value)}
                        onSearch={() => {
                            setPage(0);
                            getList();
                        }}
                    />
                </div>

                {orders.length === 0 ? (
                    <div className={'py-20 center text-center'}>
                        <p>{isLoading ? '교환 · 반품 내역을 불러오는 중입니다.' : '교환 · 반품 내역이 없습니다.'}</p>
                    </div>
                ) : (
                    <>
                        {/* Desktop */}
                        <Table className="hidden md:table border-b">
                            <Table.Head>
                                <Table.Row>
                                    <Table.Th>스토어명</Table.Th>
                                    <Table.Th>주문일자</Table.Th>
                                    <Table.Th>주문번호</Table.Th>
                                    <Table.Th>상품</Table.Th>
                                    <Table.Th>상태</Table.Th>
                                </Table.Row>
                            </Table.Head>
                            <Table.Body>
                                {orders.map((order, index) => (
                                    <Table.Row key={index}>
                                        <Table.Td>{order.store}</Table.Td>
                                        <Table.Td>
                                            {moment(order.orderedAt).format(`YYYY.MM.DD`)}
                                        </Table.Td>
                                        <Table.Td>
                                            <Link
                                                className="font-bold"
                                                to={`/mypage/refunds/${order.orderNumber}`}>
                                                {order.orderNumber} {`>`}
                                            </Link>
                                        </Table.Td>

                                        <Table.Td>
                                            {order.products.map((item, index) => (
                                                <MProductCard
                                                    key={index}
                                                    thumbnail={item.thumbnailUrl}
                                                    name={item.productName}
                                                    color={item.color}
                                                    price={item.unitPrice.toLocaleString()}
                                                    quantity={item.count}
                                                />
                                            ))}
                                        </Table.Td>
                                        <Table.Td className={'text-right font-bold'}>
                                            {order.requestType && order.requestStatus
                                                ? requestStatusCase(order.requestType, order.requestStatus)
                                                : orderStatusCase(order.status!, order.shippingStatus!)}
                                            {/*{order.requestStatus === 'PENDING' && (*/}
                                            {/*    <p className={'text-red-500 font-bold'}>배송정보 변경 가능</p>*/}
                                            {/*)}*/}
                                            {order.shippingNumber && (
                                                <>
                                                    <p className="font-normal text-13">{order.shippingCompany}</p>
                                                    <TrackingNumber shippingTrackingNumber={order.shippingNumber!} />
                                                </>
                                            )}
                                        </Table.Td>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>

                        {/* Mobile */}
                        <Section className="md:hidden">
                            <H6 className="border-b pb-2 mb-4">칼하트 온라인</H6>

                            {orders.map((apply, index) => (
                                <div className="flex justify-between items-center border-b pb-4 mb-4" key={index}>
                                    <div className="">
                                        <MProductCard
                                            thumbnail={apply.products[0].thumbnailUrl}
                                            name={apply.products[0].productName}
                                            color={apply.products[0].color}
                                            content={
                                                <>
                                                    <span className="text-brand-3">
                                                        사이즈 {apply.products[0].sizeName}
                                                    </span>
                                                    <p className="text-brand-3">
                                                        주문일자 :{' '}
                                                        {moment(apply.orderedAt).format(`YYYY.MM.DD`)}
                                                    </p>
                                                    <Link to={`/mypage/refunds/${apply.orderNumber}`}>
                                                        <p className="pt-3 text-10 font-bold">
                                                            주문번호 {apply.orderNumber} {`>`}
                                                        </p>
                                                    </Link>
                                                </>
                                            }
                                        />
                                    </div>

                                    <div>
                                        <p className="text-10 font-bold text-right">
                                            {apply.requestType && apply.requestStatus
                                                ? requestStatusCase(apply.requestType, apply.requestStatus)
                                                : orderStatusCase(apply.status!, apply.shippingStatus!)}
                                        </p>
                                        {/*{apply.requestStatus === 'PENDING' && (*/}
                                        {/*    <p className={'text-red-500 font-bold text-10'}>배송정보 변경 가능</p>*/}
                                        {/*)}*/}
                                    </div>
                                    {/*{apply.shippingNumber && (*/}
                                    {/*    <>*/}
                                    {/*        <p className="font-normal text-13">{apply.shippingCompany}</p>*/}
                                    {/*        <TrackingNumber shippingTrackingNumber={apply.shippingNumber!}/>*/}
                                    {/*    </>*/}
                                    {/*)}*/}
                                </div>
                            ))}
                        </Section>
                        <FrontPagination
                            page={page}
                            totalPages={totalPage}
                            onPrevious={() => page !== 0 && setPage(page - 1)}
                            onNext={() => page !== 10 && setPage(page + 1)}
                            onNumClick={num => setPage(num - 1)}
                        />
                    </>
                )}
            </div>
        </>
    );
};
